import { render, staticRenderFns } from "./AccountSpamView.vue?vue&type=template&id=204b6abc&"
import script from "./AccountSpamView.vue?vue&type=script&lang=js&"
export * from "./AccountSpamView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('204b6abc')) {
      api.createRecord('204b6abc', component.options)
    } else {
      api.reload('204b6abc', component.options)
    }
    module.hot.accept("./AccountSpamView.vue?vue&type=template&id=204b6abc&", function () {
      api.rerender('204b6abc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/email/account/AccountSpamView.vue"
export default component.exports